
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";

const Footer = () => {
  const handleRedirect = () => {
    window.location.href = 'https://ragnarai.netlify.app/';
  };

  return (
    <footer className="bg-estate-800 text-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center">
          <h3 className="font-display text-xl mb-4">Lionsales Solutions</h3>
          <p className="text-estate-300">
            Delivering excellence in B2B sales and technology solutions.
          </p>
        </div>
        <div className="mt-12 pt-8 border-t border-estate-700 text-center text-estate-300">
          <p>&copy; {new Date().getFullYear()} Lionsales Solutions. All rights reserved.</p>
          <a 
            href="mailto:johan@lionsales.solutions" 
            className="mt-2 inline-block hover:text-white transition-colors"
          >
            Website by johan@lionsales.solutions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
